import { IConversation, IUser } from './../../types/chat/conversation';
import { API_CHAT_URL } from 'consts/common.const';
import { Http } from 'services/http';

interface Search {
  filterUser: IUser[];
  filterGroups: IConversation[];
}

/**
 * @deprecated
 */
export const getListContact = () => {
  return Http.request<IConversation[]>({
    method: 'GET',
    url: `${API_CHAT_URL}/conversation`,
  });
};

export const getListContactBySearch = (keyword: string) => {
  return Http.request<Search>({
    method: 'GET',
    url: `${API_CHAT_URL}/conversation/user-search?keyword=${keyword}`,
  });
};
